import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
    SortingState, SelectionState, FilteringState, PagingState, RowDetailState,
    IntegratedFiltering, IntegratedPaging, IntegratedSorting, IntegratedSelection,
} from '@devexpress/dx-react-grid';
import {
    Grid,
    Table,
    TableHeaderRow, TableFilterRow, TableSelection, TableColumnResizing,
    TableColumnVisibility,
    PagingPanel, Toolbar, ColumnChooser,
} from '@devexpress/dx-react-grid-material-ui';

import CustomActionsState from '../shared/custom-grid-items/CustomActionsState';
import CustomActions from '../shared/custom-grid-items/CustomActions';
import {
    DateTypeProvider,
    DateTimeTypeProvider,
    StatoLicenzaTypeProvider,
    MultiAziendaTypeProvider,
    FilterCellComponent,
    FilterIcon,
    filtersMessages,
    filteringColumnExtensions
} from '../shared/custom-grid-items/DataFormatters';

// Material components
import {
    Paper
} from '@material-ui/core';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    paperMain: {
        padding: '10px',
        textAlign: 'right',
        minHeight: "450px",
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center'
    },
    detailContainer: {
        margin: '10px',
    },
});


class GridLicenzeCmp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            columns: [
                { name: 'SerialNumber', title: 'S/N' },
                { name: 'ProductKey', title: 'Product Key' },
                { name: 'Cliente', title: 'Cliente' },
                { name: 'Tipologia', title: 'Tipologia' },
                { name: 'Bloccata', title: 'Stato' },
                { name: 'DataDecorr', title: 'Decorrenza' },
                { name: 'DataScadenza', title: 'Scadenza' },
                { name: 'DataAttivazione', title: 'Attivazione' },
                { name: 'CodiceUtente', title: 'Cod. Utente' },
                { name: 'MultiAzienda', title: 'MultiAzienda' },
                { name: 'SerialNumberOld', title: 'S/N Old' },
                { name: 'Email', title: 'Email' },
                { name: 'HW_ID', title: 'HW_ID' },
                { name: 'NumeroReinstallazioni', title: 'n° reinstallaz.' },
                { name: 'DataUltimoAccesso', title: 'Ultimo Accesso' },
                { name: 'DataCreazione', title: 'Creazione' },
            ]
        };

    }

    componentDidUpdate(propsPrecedenti) {
        if (this.props.selectedRowIndex !== propsPrecedenti.selectedRowIndex) {
            if (this.props.selectedRowIndex === -1)
                this.props.setSelectedLicense({});
            else
                this.props.setSelectedLicense(this.props.lista_licenze[this.props.selectedRowIndex]);
        }
    }

    render() {
        const { classes, getLicenses, resetFilters, codiceUtente } = this.props;

        return (
            <div>
                <Paper className={classes.paperMain}>
                    <Grid
                        rows={this.props.lista_licenze}
                        columns={this.state.columns}
                    >
                        <StatoLicenzaTypeProvider for={['Bloccata']} />
                        <MultiAziendaTypeProvider for={['MultiAzienda']} />
                        <DateTypeProvider for={['DataDecorr', 'DataScadenza', 'DataAttivazione']} />
                        <DateTimeTypeProvider for={['DataUltimoAccesso', 'DataCreazione']} />

                        <FilteringState
                            filters={this.props.filters}
                            onFiltersChange={filters => this.props.onFiltersChange(filters)}
                        />

                        <SortingState
                            sorting={this.props.sorting}
                            onSortingChange={sorting => this.props.onSortingChange(sorting)}
                        />

                        <PagingState
                            currentPage={this.props.currentPage}
                            onCurrentPageChange={currentPage => this.props.onCurrentPageChange(currentPage)}
                            pageSize={this.props.pageSize}
                            onPageSizeChange={pageSize => this.props.onPageSizeChange(pageSize)}
                        />

                        <SelectionState
                            selection={this.props.selection}
                            onSelectionChange={newSelection => this.props.handleRowSelection(newSelection)}
                        />
                        
                        {/*<RowDetailState
                            expandedRowIds={this.props.expandedRowIds}
                            onExpandedRowIdsChange={expandedRowIds => this.props.handleExpandedRow(expandedRowIds)}
                        />*/}
                        
                        <IntegratedFiltering columnExtensions={filteringColumnExtensions} />
                        <IntegratedSorting />
                        <IntegratedPaging />
                        <IntegratedSelection />

                        <Table />

                        <TableColumnResizing
                            columnWidths={this.props.columnWidths}
                            onColumnWidthsChange={widths => this.props.onColumnWidthsChange(widths)}
                        />

                        <TableColumnVisibility
                            hiddenColumnNames={this.props.hiddenColumnNames}
                            onHiddenColumnNamesChange={columnNames => this.props.OnHiddenColumnChange(columnNames)}
                        />

                        <TableSelection
                            highlightRow
                            selectByRowClick
                            showSelectionColumn={false}
                        />

                        <TableFilterRow cellComponent={FilterCellComponent}
                            showFilterSelector
                            iconComponent={FilterIcon}
                            messages={filtersMessages}
                        />

                        <TableHeaderRow showSortingControls />
                        <CustomActionsState
                            onRefreshClick={() => getLicenses(codiceUtente)}
                            onResetClick={() => resetFilters()}
                        />

                        <Toolbar />
                        <ColumnChooser />
                        <CustomActions />

                        <PagingPanel pageSizes={this.props.pageSizes} />

                    </Grid>
                </Paper>
            </div>
        );

    }
}

GridLicenzeCmp.propTypes = {
    getLicenses: PropTypes.func.isRequired,
    getLicensesRequestStatus: PropTypes.string.isRequired,
    lista_licenze: PropTypes.arrayOf(PropTypes.object).isRequired,

    setSelectedLicense: PropTypes.func.isRequired,

    resetFilters: PropTypes.func.isRequired,
};

export default withStyles(styles)(GridLicenzeCmp);